import React, { useState, Fragment } from "react"
import { useHistory } from "react-router-dom"
import { MdLogout } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { userLogout } from "utils"
import { ConfirmationModal } from "components"
import classes from "./LogoutButton.module.scss"

const LogoutButton = () => {
  const [t] = useTranslation()

  const history = useHistory()

  const [openModal, setOpenModal] = useState(false)

  const handleLogout = () => {
    userLogout()

    history.push("/")
  }

  return (
    <Fragment>
      <div
        onClick={() => setOpenModal(true)}
        className={classes["container"]}
      >
        <span>{t("خروج")}</span>
        <MdLogout size={20} />
      </div>
      <ConfirmationModal
        title={t("آیا_می_خواهید_از_برنامه_خارج_شوید")}
        show={openModal}
        onConfirm={handleLogout}
        onHide={() => setOpenModal(false)}
      />
    </Fragment>
  )
}

export default LogoutButton